import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Result } from 'app/core/models/result';
import { CompanyService } from 'app/company/services/company.service';
import { CompanyListModel } from 'app/company/models/company-list.model';
import { UserService } from 'app/core/services/user.service';
import { UserType } from '../../../account/models/user-type.model';

@Component({
    selector: 'app-user-company-add',
    templateUrl: './user-company-add.component.html',
    styleUrls: ['./user-company-add.component.css']
})
export class UserCompanyAddComponent implements OnInit {
    errors: string[];
    companies: CompanyListModel[];
    addCompanyFrom: FormGroup;
    submitAttempt: boolean = false;
    @Input() userId: string;
    @Input() isEditMode: boolean = false;
    @Output() userCompanyAdded: EventEmitter<string> = new EventEmitter<string>();
    userTypes: UserType[];

    constructor(
        private companyService: CompanyService,
        private userService: UserService,
        private fb: FormBuilder,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.getCompanies();

        this.addCompanyFrom = this.fb.group({
            userId: [this.userId],
            companyId: ['', Validators.required],
            userTypeId: ['', Validators.required]
        });

        this.userService.getUserTypes().subscribe(
            userTypes => this.userTypes = userTypes,
            error => {
                console.log(error);
            }
        );
    }
    
    getCompanies(): void {
        this.companyService.getAll().subscribe(result => {
            this.companies = result;
        });
    }

    addCompanyToUser(): void {
        this.submitAttempt = true;
        if (this.addCompanyFrom.valid) {
            const formValue = this.addCompanyFrom.value;
            formValue.userId = this.userId;
            this.userService.addCompanyToUser(formValue).subscribe(
                result => {
                    this.userCompanyAdded.emit(result);
                    this.addCompanyFrom.reset();
                    this.submitAttempt = false;
                    this.modalService.dismissAll('saved');
                },
                error => {
                    this.errors = (<Result>error).errorList;
                    this.submitAttempt = false;
                }
            );
        }
    }

    openAddCompany(content) {
        this.modalService.open(content);
    }
}
